const env = process.env.API_ENV || "development";

const urls = {
  production: {
    LUCINA_URL: "https://api-lucina.com",
    SITE_URL: "https://www.cookingncocktails.com",
  },
  staging: {
    LUCINA_URL: "https://internal.minerva.dev/staging/lucina-api",
    SITE_URL: "",
  },
  development: {
    LUCINA_URL: "http://localhost:8080",
    SITE_URL: "http://localhost:3000",
  },
};

const { LUCINA_URL, SITE_URL } = urls[env];

const LUCINA_DOMAIN = "cookingncocktails.com";

let ROUTER_BASENAME; // eslint-disable-line
switch (process.env.API_ENV) {
  case `staging`:
    ROUTER_BASENAME = `/staging/cooking-and-cocktails`;
    break;
  case `production`:
    ROUTER_BASENAME = ``;
    break;
  default:
    ROUTER_BASENAME = ``;
}

const GHOST_URL = `https://cooking-and-cocktails.ghost.io`;
const GHOST_KEY = `bfc41db66c355c966e206aa410`;

const GOOGLE_ANALYTICS_TAG = ``;

module.exports = {
  LUCINA_URL,
  SITE_URL,
  LUCINA_DOMAIN,
  ROUTER_BASENAME,
  GOOGLE_ANALYTICS_TAG,
  GHOST_URL,
  GHOST_KEY,
};
